(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jaycee-document-chooser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jaycee-document-chooser')) {
  customElements.define('jaycee-document-chooser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.groups = ['size', 'colour', 'service'].map(name => this.querySelector(`[data-step="${name}"]`));
      this.routes = Array.from(this.querySelectorAll('[data-route]')).map(node => ({...node.dataset}));
      this.querySelector('[data-interactive]').hidden = false;
      this.addEventListener('change', event => {
        const index = this.groups.indexOf(event.target.closest('fieldset'));
        if (index < 0) return;
        this.groups.slice(index + 1).forEach(group => group.querySelectorAll('input').forEach(input => { input.checked = false; }));
        this.update();
      });
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.querySelectorAll('input').forEach(input => { input.checked = false; });
        this.update();
        this.groups[0].querySelector('input:not(:disabled)')?.focus();
      });
      this.querySelector('[data-browse]').addEventListener('click', () => {
        const next = this.closest('.shopify-section')?.nextElementSibling;
        const target = next?.querySelector('.product-list') || next;
        if (!target) return;
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      });
      this.update();
    }
    update() {
      const selection = {};
      this.groups.forEach((group, index) => {
        const name = group.dataset.step;
        group.disabled = index > 0 && !selection[this.groups[index - 1].dataset.step];
        group.querySelectorAll('input').forEach(input => {
          input.disabled = !this.routes.some(route => Object.entries(selection).every(([key, value]) => route[key] === value) && route[name] === input.value);
          if (group.disabled || input.disabled) input.checked = false;
        });
        const checked = group.querySelector('input:checked');
        if (checked) selection[name] = checked.value;
      });
      this.querySelector('[data-mixed-note]').hidden = selection.colour !== 'mixed';
      const result = this.querySelector('[data-result]');
      const link = this.querySelector('[data-result-link]');
      const match = Object.keys(selection).length === 3 ? this.routes.find(route => Object.entries(selection).every(([key, value]) => route[key] === value)) : null;
      result.hidden = !match;
      this.querySelector('[data-result-title]').textContent = match?.title || '';
      if (match) link.href = match.url;
      else link.removeAttribute('href');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaycee-price-estimator"] && !Shopify.designMode) return;
  try {
    
class JayceeEstimator extends HTMLElement {
 connectedCallback() {
  if(this.ready)return;this.ready=true;
  this.data=JSON.parse(this.querySelector('[data-catalog]').textContent);this.t=JSON.parse(this.querySelector('[data-text]').textContent);
  this.area=this.querySelector('[data-controls]');this.result=this.querySelector('[data-result]');
  this.group=this.select(this.area,this.t.service,[['documents',this.t.documents],['finish',this.t.finish],['card',this.t.cards],['plan',this.t.plans]],()=>this.products());
  this.product=this.select(this.area,this.t.product,[],()=>this.fields());this.options=this.el('div',this.area);this.products();
 }
 option(text,value){const o=document.createElement('option');o.textContent=text;o.value=value;return o;}
 el(tag,parent,text){const e=document.createElement(tag);if(text!==undefined)e.textContent=text;parent.append(e);return e;}
 select(parent,label,options,change){const wrap=this.el('label',parent);this.el('span',wrap,label);const s=this.el('select',wrap);options.forEach(([value,text])=>s.add(this.option(text,value)));if(options.length)s.value=options[0][0];s.addEventListener('change',change);return s;}
 number(label,value,min=1){const wrap=this.el('label',this.options);this.el('span',wrap,label);const input=this.el('input',wrap);input.type='number';input.min=min;input.max=100000;input.step=1;input.value=value;input.addEventListener('input',()=>this.calculate());return input;}
 products(){const keep=this.product.value;this.product.replaceChildren();this.data.filter(p=>this.group.value==='documents'?['bind','mixed'].includes(p.kind):p.kind===this.group.value).forEach(p=>this.product.add(this.option(p.title,p.handle)));if([...this.product.options].some(o=>o.value===keep))this.product.value=keep;this.fields();}
 field(pattern){return this.p.fields?.find(f=>pattern.test(f.title||''));}
 pick(label,items,none=false){const choices=items.map((x,i)=>[String(i),x.title||x.l]);if(none)choices.unshift(['-1',this.t.none]);return this.select(this.options,label,choices,()=>this.calculate());}
 fields(){this.p=this.data.find(p=>p.handle===this.product.value);this.options.replaceChildren();this.inputs={};const p=this.p;if(!p)return;
  if(p.kind==='plan'){
   p.variantOptions.forEach((o,i)=>{this.inputs['v'+i]=this.select(this.options,o.label,o.values.map(v=>[v,v]),()=>this.calculate());});
  }else{
   this.inputs.qty=this.number(this.t.copies,1);
   if(['bind','mixed'].includes(p.kind)){this.inputs.pages=this.number(this.t.pages,10);this.el('p',this.options,this.t.page_help);}
   if(p.kind==='mixed'){this.inputs.colour=this.number(this.t.colour_pages,2,0);this.el('p',this.options,this.t.mixed_help);}
   if(p.kind==='finish'){this.inputs.sheets=this.number(this.t.sheets,1);this.el('p',this.options,this.t.sheet_help);}
   if(p.kind!=='card')this.inputs.sides=this.select(this.options,this.t.sides,[['single',this.t.single],['double',this.t.double]],()=>this.calculate());
   if(p.kind==='bind'||(p.kind==='mixed'&&p.uc)){
    const stock=p.uc.find(f=>/Paper Options/i.test(f.l));if(stock)this.inputs.stock=this.pick(this.t.paper,stock.o);
    const b=p.uc.find(f=>/Binding Options/i.test(f.l));this.binding=b?.o||[];if(this.binding.length)this.inputs.binding=this.pick(this.t.binding,this.binding);
   }else if(p.kind==='mixed'){
    const b=this.field(/^Binding$/i);this.binding=b?.items||[];this.inputs.binding=this.pick(this.t.binding,this.binding);
   }else if(p.kind==='finish'){
    this.stock=this.field(/Paper\/Card Stock/i).items;this.inputs.stock=this.pick(this.t.paper,this.stock);
    this.lamination=this.field(/Lamination/i).items;this.inputs.lamination=this.pick(this.t.lamination,this.lamination,true);
    this.folding=this.field(/Folding/i).items;this.inputs.folding=this.pick(this.t.folding,this.folding,true);
   }else if(p.kind==='card'){
    this.sizes=this.field(/Card Size/i).items;this.inputs.size=this.pick(this.t.size,this.sizes);
    this.stock=this.field(/Paper\/Card Stock/i).items;this.inputs.stock=this.pick(this.t.paper,this.stock);
   }
  }
  this.calculate();
 }
 calculate(){const p=this.p,i=this.inputs,t=this.t;this.result.replaceChildren();let price=0,printing=0,finishing=0,setup=0,variant=null,warning='';const currency=n=>new Intl.NumberFormat('en-IE',{style:'currency',currency:'EUR'}).format(n);const number=k=>Number(i[k]?.value);const value=k=>i[k]?.value;let valid=true;
  Object.values(i).forEach(e=>{if(e.type==='number'&&(!e.checkValidity()||!Number.isInteger(Number(e.value))))valid=false;});
  const qty=number('qty'),pages=number('pages'),double=value('sides')==='double';
  if(valid&&p.kind==='plan'){
   variant=p.variants.find(v=>v.options.every((o,n)=>o===value('v'+n)));if(variant?.available){price=Number(variant.price);printing=price;}else warning=t.unavailable;
  }else if(valid&&p.kind==='finish'){
   const sheets=number('sheets')*qty,impressions=sheets*(double?2:1),factor=impressions<100?1:impressions<200?p.tiers[0]:p.tiers[1];
   printing=Number(this.stock[number('stock')].price)*factor*impressions;
   finishing=((this.lamination[number('lamination')]?.price||0)+(this.folding[number('folding')]?.price||0))*sheets;setup=2;price=printing+finishing+setup;
  }else if(valid&&p.kind==='card'){
   const stock=this.stock[number('stock')];if(stock.price_type!=='fixed'&&Number(stock.price)!==0){warning=t.premium_check;}else{printing=(Number(stock.price)+Number(this.sizes[number('size')].price))*qty;setup=2;price=printing+setup;}
  }else if(valid){
   const b=this.binding[number('binding')],label=b?.title||b?.l||'';let charge=Number(b?.price||0);
   if(p.uc){const match=String(b?.a||'0').match(/^([\d.]+)(?: \* totalFileQuantity)?$/);if(match)charge=Number(match[1]);else warning=t.check_price;}
   let billedPages=pages;
   if(/Booklet/i.test(label)){if(!double||pages>48)warning=t.booklet_limit;else billedPages=Math.ceil(pages/4)*4;}
   const sheets=double?Math.ceil(billedPages/2):billedPages;
   if(/Corner/i.test(label)&&sheets>24)warning=t.staple_limit;
   if(/Wire|Wiro/i.test(label)&&sheets>200)warning=t.wire_limit;
   if(/Thermal/i.test(label)&&sheets>150)warning=t.thermal_limit;
   if(p.kind==='mixed'){
    const colour=number('colour');if(colour>pages){valid=false;}else if(p.uc){warning=t.mixed_check;}else{
     const bw=Number(this.field(/Black pages/i).price),col=Number(this.field(/Colour pages/i).price);printing=((billedPages-colour)*bw+colour*col)*qty;setup=2;
    }
   }else printing=billedPages*p.rate*qty;
   finishing=charge*qty;price=Math.max(2,printing+finishing+setup);
  }
  this.el('p',this.result,t.estimate).className='je-kicker';
  const total=this.el('div',this.result,valid&&!warning?currency(price):t.check_options);total.className='je-total';
  if(!valid)this.el('p',this.result,t.invalid).setAttribute('role','alert');
  else if(warning)this.el('p',this.result,warning);
  else{
   const dl=this.el('dl',this.result);[[t.printing,printing],[t.finishing,finishing],[t.setup,setup]].filter(([_,n])=>n>0).forEach(([l,n])=>{this.el('dt',dl,l);this.el('dd',dl,currency(n));});
   if(price>printing+finishing+setup)this.el('p',this.result,t.minimum);
   this.el('p',this.result,t.tax);
  }
  this.el('p',this.result,p.title).className='je-match';
  const link=this.el('a',this.result,t.continue);link.className='je-button';link.href=this.dataset.root+'products/'+p.handle+(variant?'?variant='+variant.id:'');
  this.el('p',this.result,t.handoff).className='je-small';this.el('p',this.result,t.note).className='je-small';
 }
}
if(!customElements.get('jaycee-estimator'))customElements.define('jaycee-estimator',JayceeEstimator);


  } catch(e) { console.error(e); }
})();
})();
